/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Senior_TrainingInputs */

const en_service_type_senior_training = /** @type {(inputs: Service_Type_Senior_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training for older adults`)
};

const pl_service_type_senior_training = /** @type {(inputs: Service_Type_Senior_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening dla seniorów`)
};

/**
* | output |
* | --- |
* | "Training for older adults" |
*
* @param {Service_Type_Senior_TrainingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_senior_training = /** @type {((inputs?: Service_Type_Senior_TrainingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Senior_TrainingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_senior_training(inputs)
	return en_service_type_senior_training(inputs)
});